/** Whole years, against a `date`-only birth date: the client twin of `core/clock.py`'s
 *  `age_on` — the value never travels the wire, so both sides compute it. */
export function ageOn(birthDate: string, today: Date): number {
  const year = Number(birthDate.slice(0, 4))
  const month = Number(birthDate.slice(5, 7))
  const day = Number(birthDate.slice(8, 10))
  const hadBirthday =
    today.getMonth() + 1 > month || (today.getMonth() + 1 === month && today.getDate() >= day)
  return today.getFullYear() - year - (hadBirthday ? 0 : 1)
}

/** The year a person was born, read off the text of the `date`: `new Date('2011-03-14')` is midnight
 *  UTC, and a zone behind it is the day before. `null` for who has no date on file. */
export function birthYearOf(person: { readonly birth_date?: string | null }): number | null {
  return person.birth_date == null ? null : Number(person.birth_date.slice(0, 4))
}

/** The age from which a player decides alone (spec #278): under it, the tutore confirms. */
export const GUARDIAN_AGE = 14

/** The day a `date`-only birth date turns `years`, as `ageOn` counts it: born on 29 February, the
 *  birthday of a common year is 1 March. */
export function birthdayAt(birthDate: string, years: number): string {
  const year = Number(birthDate.slice(0, 4)) + years
  const monthDay = birthDate.slice(5)
  const leap = (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0
  return monthDay === '02-29' && !leap ? `${String(year)}-03-01` : `${String(year)}-${monthDay}`
}
